/*
  Project index: type filters (?type=slug), Two/Four/Six column switcher, Magnific Popup lightbox.
  Switcher mirrors the live Webflow script: inline grid columns, clicked button black, the others gray.
*/
(function () {
  function init(root) {
    const grid = root.querySelector('.grid-wrapper');
    if (!grid || root.dataset.mfReady) return;
    root.dataset.mfReady = 'true';
    const items = Array.from(grid.children);
    const buttons = Array.from(root.querySelectorAll('[data-mf-cols]'));
    const filters = Array.from(root.querySelectorAll('[data-mf-type]'));

    // ---------- Columns ----------
    function setColumns(count) {
      grid.style.gridTemplateColumns = 'repeat(' + count + ', 1fr)';
      // Let the browser pick a file that fits the new column width
      const width = Math.ceil(grid.clientWidth / count) + 'px';
      grid.querySelectorAll('img').forEach((img) => { img.sizes = width; });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        setColumns(+button.dataset.mfCols);
        buttons.forEach((other) => { other.style.color = 'gray'; });
        button.style.color = 'black';
      });
    });
    const defaultButton = buttons.find((button) => button.hasAttribute('data-mf-cols-default'));
    if (defaultButton) defaultButton.style.color = 'black';
    setColumns(+(root.dataset.mfColumns || 4));

    // ---------- Filters ----------
    function applyType(type) {
      const known = filters.some((link) => link.dataset.mfType === type);
      if (!known) type = '';
      items.forEach((item) => {
        item.hidden = type !== '' && !(item.dataset.types || '').split(' ').includes(type);
      });
      filters.forEach((link) => {
        const current = link.dataset.mfType === type && !link.hasAttribute('data-mf-type-under');
        link.classList.toggle('w--current', current);
        if (current) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    filters.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const type = link.dataset.mfType;
        const url = new URL(window.location.href);
        if (type) url.searchParams.set('type', type);
        else url.searchParams.delete('type');
        history.replaceState(null, '', url);
        applyType(type);
      });
    });
    applyType(new URLSearchParams(window.location.search).get('type') || '');

    // ---------- Lightbox (only the images currently shown) ----------
    if (window.jQuery && window.jQuery.fn.magnificPopup) {
      window.jQuery(grid).magnificPopup({
        delegate: '.w-dyn-item:not([hidden]) .skate-img',
        type: 'image',
        gallery: { enabled: true },
        mainClass: 'mfp-fade',
      });
    }
  }

  document.querySelectorAll('[data-mf-project-index]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mf-project-index]').forEach(init);
  });
})();
